var map = {
	"./IMG_20220904_105144.jpg": 1990,
	"./IMG_20220904_105159.jpg": 8932,
	"./IMG_20220904_105218.jpg": 2190,
	"./IMG_20220904_105242.jpg": 5186,
	"./IMG_20220904_105324.jpg": 4096,
	"./IMG_20220904_105338.jpg": 5691,
	"./IMG_20220904_105359.jpg": 198,
	"./IMG_20220904_105410.jpg": 9442,
	"./IMG_20220904_105429.jpg": 4017,
	"./IMG_20220904_105518.jpg": 5181,
	"./IMG_20220904_105554.jpg": 4336,
	"./IMG_20220904_105630.jpg": 9050,
	"./IMG_20220904_105636.jpg": 4129,
	"./IMG_20220904_105748.jpg": 16,
	"./IMG_20220904_105815.jpg": 7373,
	"./IMG_20220904_105845.jpg": 589,
	"./IMG_20220904_105919.jpg": 9175,
	"./IMG_20220904_105932.jpg": 8850,
	"./IMG_20220904_112012.jpg": 1777,
	"./IMG_20220904_112053.jpg": 6445,
	"./IMG_20221010_213820.jpg": 4453,
	"./IMG_20221010_213847.jpg": 842,
	"./IMG_20221010_213919.jpg": 3989,
	"./IMG_20221010_213938.jpg": 3074,
	"./armchair.png": 8441,
	"./coffee-mug.png": 9805,
	"./home.png": 7018,
	"./reading.png": 5478,
	"./relax.png": 3281,
	"./stay-home.png": 7952,
	"./stretching.png": 9751,
	"./window.png": 6047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2026;